var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77748 13.7225C4.44114 13.3862 4.41057 12.8599 4.68575 12.489L4.77748 12.3827L9.15979 8L4.77748 3.61726C4.44114 3.28092 4.41056 2.75461 4.68575 2.38373L4.77748 2.27748C5.11381 1.94114 5.64013 1.91057 6.011 2.18575L6.11726 2.27748L11.1699 7.33011C11.5062 7.66645 11.5368 8.19276 11.2616 8.56364L11.1699 8.66989L6.11726 13.7225C5.74729 14.0925 5.14745 14.0925 4.77748 13.7225Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarRightArrow);
export default __webpack_public_path__ + "static/media/calendar-right-arrow.1a81fbf7f0776d347ae0341fdc2920aa.svg";
export { ForwardRef as ReactComponent };